import React, { useEffect, useRef, useState } from 'react';
import Link from 'next/link';
import {
  Section,
  SectionList,
  SectionTitle,
  SidebarContainer,
  SectionListVoice,
  LinkStyled,
} from './Sidebar.style';
import { Section as FilterSection } from '../../models/domain/interfaces';
import { useTheme, useMediaQuery } from '@mui/material';
import { getCompany } from '../../utils/company';
import { Companies } from '../../models/domain/enum';

interface IProps {
  sections: FilterSection[];
}

const RENDER_FIXER = 6;

const Sidebar: React.FunctionComponent<IProps> = (props: IProps) => {
  const { sections } = props;
  const section = useRef<any>();
  const theme = useTheme();
  const isSlowerThanMd = useMediaQuery(theme.breakpointsMediaQuery.down('lg'));
  const company = getCompany();

  const baseValue = isSlowerThanMd
    ? 70
    : company === Companies.SIRMAN
      ? 210
      : 150;
  const fixer = isSlowerThanMd ? 70 : 0;

  const [scrollTop, setScrollTop] = useState(baseValue);
  const [minMaxNecessary] = useState(true);
  const [render, setRerender] = useState<number>(0);

  useEffect(() => {
    const onScroll = () => {
      const position = (section?.current as any)?.getBoundingClientRect();

      if (!position) return;

      setScrollTop(
        parseInt(position.y) >= baseValue
          ? parseInt(position.y) + fixer
          : baseValue + fixer
      );

      if (parseInt(position.y) < baseValue) {
        (section?.current as any).style.overflowY = 'hidden';
      } else {
        (section?.current as any).style.overflowY = 'auto';
      }
    };
    document?.body?.addEventListener('scroll', onScroll);

    if (render < RENDER_FIXER) {
      setRerender(render + 1);
      onScroll();
    }

    return () => document?.body?.removeEventListener('scroll', onScroll);
  }, [baseValue, fixer, render, scrollTop]);

  useEffect(() => {
    const position = (section?.current as any)?.getBoundingClientRect();
    setScrollTop(
      parseInt(position.y) > baseValue
        ? parseInt(position.y) + fixer
        : baseValue + fixer
    );
  }, [baseValue, fixer]);

  return (
    <SidebarContainer
      ref={section}
      baseValue={baseValue}
      scrollTop={scrollTop}
      minMaxNecessary={minMaxNecessary}
    >
      {sections?.map((section, indexSection) => {
        return (
          <Section key={indexSection}>
            <SectionTitle title={section?.title}>{section?.title}</SectionTitle>
            <SectionList>
              {section?.voices?.map((voice, indexVoice) => (
                <SectionListVoice key={indexVoice}>
                  <Link
                    href={
                      voice?.link.startsWith('/')
                        ? voice?.link
                        : '/' + voice?.link
                    }
                    passHref
                    prefetch={false}
                  >
                    <LinkStyled active={voice?.active}>
                      {voice?.label}
                    </LinkStyled>
                  </Link>
                </SectionListVoice>
              ))}
            </SectionList>
          </Section>
        );
      })}
    </SidebarContainer>
  );
};

export default Sidebar;
